<script lang="ts">
	import type { Waypoint } from '$lib/components/map/types';
	import { Marker } from 'svelte-maplibre';

	interface Props {
		routesWaypoint: Waypoint;
	}

	const { routesWaypoint }: Props = $props();
</script>

<!--
    TO DO : should validate the color with the design team
	I put the color coloredneutral-strongest for the border because on the figma there is a rework and for i did not find the code color
-->
<Marker lngLat={routesWaypoint.location}>
	<div class="bg-white rd-full w-3 h-3 flex justify-center items-center">
		<div class="border-solid rd-full b-1.5 border-coloredneutral-strongest bg-origin w-2 h-2"></div>
	</div>
</Marker>
